module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page-w540.aba0d019.webp";